/* eslint-disable @typescript-eslint/no-explicit-any */

import StorageAdapter from '../interface';
import BaseAdapter from '../base';

export default class LocalStorageAdapter extends BaseAdapter implements StorageAdapter {
  getItem(key: string): any {
    return this.parse(localStorage.getItem(key));
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, this.stringify(value));
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
